import type { ReactElement } from "react";

import type { Badge } from "@similarweb/ui-components";
import { Box, Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { DROPDOWN_MODELS } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/components/model-dropdown/consts";
import type { LLModel } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

interface IModelItemProps {
    model: LLModel;
    badge?: ReactElement<typeof Badge>;
    paddingLeft?: string;
}

export const ModelItem = ({ model, badge, paddingLeft = "15px" }: IModelItemProps) => {
    const item = DROPDOWN_MODELS?.[model];
    if (!item) {
        return null;
    }

    const { Icon, color } = item;

    return (
        <Flex
            alignItems="center"
            margin="8px 0"
            gap="12px"
            style={{ paddingLeft, textIndent: 2 }}
        >
            <Icon
                size="sm"
                color={color}
            />
            {translate(item.displayNameKey)}
            {badge ? (
                <Box
                    className="item-badge"
                    margin="0 4px 0 0"
                >
                    {badge}
                </Box>
            ) : null}
        </Flex>
    );
};
